import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getReduxStore } from '../globals';
import { shoppingListAddItems, addSLItemsClearStatus } from '../actions/shop_list_actions';
import AddItemRow from './add_item_row';
import _ from 'lodash';
import '../css/common.css';
import '../css/add_item.css';

class AddItems extends Component {

    constructor(props) {
        super(props);
        
        var l = this.sortListByDept(this.props.currentItemList);
        //var l = this.sortListByName(this.props.currentItemList);

        this.state = { currentItemList: l, currentFilter: '', currentSort: 'Dept', isDirty: false, addedItems: [] }
      }
    
    componentDidMount() {
        getReduxStore().dispatch(addSLItemsClearStatus());
    }
  
    sortListByDept(l) {
        return l.sort(function(a, b)
                    {
                        return (a.Default_Location <  b.Default_Location) ? -1 : 0;
                    });
    }

    sortListByName(l) {
        return l.sort(function(a, b)
                {
                    return (a.Item_Name <  b.Item_Name) ? -1 : 0;
                });
    }

    itemSelected(item) {
        var l = this.state.addedItems;
        l.push(item);
        this.setState({isDirty: true, addedItems: l})
    }

    itemRemoved(item) {
        var l = this.state.addedItems;
        var i = this.findAddItemIndex(item);
        if (i !== -1) {
            l.splice(i,1);
            this.setState({isDirty: true, addedItems: l});
        }

        if (l.length === 0) { 
            this.setState({ isDirty: false })
        };
    }

    findAddItemIndex(item) {
        return this.state.addedItems.findIndex(itm => (itm.Account_Id === item.Account_Id) && (itm.Item_Id === item.Item_Id))
    }

    itemChanged(item) {
        var l = this.state.addedItems;
        var i = this.findAddItemIndex(item);
        if (i !== -1) {
            l[i] = item;
            this.setState({isDirty: true, addedItems: l});
        }
    }

    saveClicked() {
        getReduxStore().dispatch(shoppingListAddItems(this.props.shopList, this.state.addedItems));
//        this.setState({isDirty: true, shopList: this.props.shopList });    
    }

    showItemList() {
        var curDept = '';
        var evenRow = false;

        return  _.map(this.state.currentItemList, item => {
            var key = item.Account_Id.toString() + item.Item_Id.toString();
            
            if (item.Default_Location === curDept) {
                evenRow = !evenRow;
                return (
                    <AddItemRow 
                        key={key} 
                        item={item}
                        itemSelected={this.itemSelected.bind(this)}
                        itemRemoved={this.itemRemoved.bind(this)}
                        itemChanged={this.itemChanged.bind(this)}
                        evenRow={evenRow}
                    />
                );
            } 
            else {
                curDept = item.Default_Location;
                if (this.state.currentSort === "Dept") {
                    return (<div key={key} className="ultra-light-bk ulAddItemRowDivider main-font">{curDept}</div>);
                }
                else
                { 
                    return null 
                }
            }
            }
        );
    }

    render() {
      return (
        <div id="AddItem-Main" className="main-font">
            <div id="divTopBar">
                { this.props.saveError.length > 0 ? <div>{this.props.saveError}</div> : null }
                {this.state.isDirty ? 
                    <div id="divSave" className="lt-blue-font">
                        <span
                            style={{ cursor: 'pointer'}} 
                            className="grn-brdr light-bk"
                            onClick={this.saveClicked.bind(this)}
                        >Save</span>
                    </div> 
                    : 
                    null
                }
            </div> 
            <div id="divAddItemListContainer" className={this.state.isDirty ? "grn-brdr ht96Pct" : "grn-brdr ht100Pct"} >
                <ul id="ulAddItemList" className="no-bullet-ul">                
                    {this.showItemList()}
                </ul>
            </div>
        </div>
      );
    }
  };
  
  function mapStateToProps(state) {
    return {  addItemsInProgess: state.current_shop_list.add_items_open, saveError:  state.current_shop_list.addItemsError };
  }
  
  export default connect(mapStateToProps) (AddItems);


// WEBPACK FOOTER //
// ./src/components/add_items.js